module.exports = __webpack_public_path__ + "img/lesjuristes.39e3addd.png";